import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { UncontrolledCarousel } from 'reactstrap';
import ReactInputMask from 'react-input-mask';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { DateTime } from 'luxon';

import { THEME_DEFAULT } from '../../utils/common'

import { parseTheme } from '../../utils/common'
import { useStyles } from '../../styles/WelcomeSignupStyles'

import { isAuthenticated, switchDarkMode } from '../../../features/session/sessionSlice';
import history from '../../../history'
import NonAuthHeader from '../Layout/NonAuthHeader';
import { apiCall } from '../../utils/ApiUtils';

import monitorImg from '../../../assets/images/monitor.png'
import blueBkImg from '../../../assets/images/blue-background-hex.png'
const INITIAL_STATE = { 
    loading: true,
    submitting: false,
    showServiceBranch: false,
    showBusinessType: true,
    showDemoButton: true,
    partnerLogo: null,
    webTitle: "The Insights Engine",
    brand: "",
    protocol: "http://",
    domain: "",
    contactFirstName: "",
    contactLastName: "",
    email: "",
    cellPhone: "",
    websiteType: "",
    militaryBranch: "",
    referral: null
}

function WelcomeSignup(props){
    const now = DateTime.local()

    const [state,setState] = useState(INITIAL_STATE)
    const isAuth = useSelector(isAuthenticated);
    const theme = parseTheme()

    const dispatch = useDispatch()

    const classes = useStyles()

    const emailRef = useRef()

    const location = useLocation();
    let localDomain = window.localStorage.domain
    const origin = window.location.host !== "localhost" ? window.location.origin : localDomain ? `https://${localDomain}` : "https://engine.internetstrategylabs.com"

    useEffect(() => {
        dispatch(switchDarkMode(false))
        let rootUrl = `${window.location.host.includes('localhost') ?'http://localhost:3005': origin.replace('staging.', 'api.').replace('app.', 'api.').replace('engine.internet', 'api.internet')}`
        
        let promises = [fetch(`${rootUrl}/theme?origin=${origin}`)]
        
        if(props?.match?.params?.salesToken){
            promises.push(fetch(`${rootUrl}/sales-token/${props?.match?.params?.salesToken}`))
        }
        Promise.all(promises)
        .then(async([resp, respToken]) => {  
            let response = await resp.json()

            const appendedState = {
                webTitle: response.title ?? "The Insights Engine",
                loading: false
            }

            document.title = `${response?.title ?? "The Insights Engine"} | Welcome`

            let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = response.favIcon;

            document.getElementsByTagName('head')[0].appendChild(link);

            if(respToken){
                const responseToken = await respToken.json()

                if(responseToken.logo !== null){
                    appendedState.partnerLogo = responseToken.logo
                }
                appendedState.showServiceBranch = responseToken?.useServiceBranch ?? false
                if(responseToken?.showBusinessType === false){
                    appendedState.showBusinessType = false
                }
                appendedState.showDemoButton = false
                
                if(responseToken?.backgroundImage !== null){
                    appendedState.backgroundImage = responseToken.backgroundImage
                }

                if(responseToken?.trialExtensionOverrideDays !== null){
                    appendedState.trialExtensionOverrideDays = responseToken.trialExtensionOverrideDays
                }
            }

            setState(prev => ({
                ...prev,
                ...appendedState
            }))
        }).catch(e => {
            setState(prev => ({
                ...prev,
                loading: false
            }))
        })
    }, [location, props?.match])

    useEffect(() => {
        window.rewardful('ready', function() {
            setState(prev => ({
                ...prev,
                referral: window.Rewardful.referral
            }))
        });
    }, []);

    const onInputChange = (e) => {
        setState(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const previewSite = (e) => {
        e.preventDefault();
        const site = state.protocol + state.domain

        window.open(site, "_blank", 'noopener,noreferrer')
    }
    
    const onSubmitForm = async(e) => {
        e.preventDefault()
        setState(prev => ({
            ...prev,
            submitting: true
        }))

        const {
            contactFirstName,
            contactLastName,
            email,
            protocol,
            brand,
            domain, 
            websiteType,
            militaryBranch,
            cellPhone,
            referral
        } = state

        const queryParams = new URLSearchParams(location.search)

        const params = ["utm_source", "utm_campaign", "utm_medium"]
        const body = {
            contactFirstName,
            contactLastName,
            email,
            protocol,
            brand,
            domain, 
            websiteType,
            militaryBranch,
            cellPhone,
            referral
        }

        if (location.search?.includes("quickstats")) {
            body["status"] = "evaluation"
        } else {
            body["status"] = "onboarding"
        }

        if (location.search?.includes("test-onboarding")) {
            body["test-onboarding"] = true
        }

        if (location.search?.includes("frandev")) {
            body['isFranchise'] = true
        }

        params.forEach(function(p) {
            if (queryParams.has(p)) {
                body[p] = queryParams.get(p)
            }
        })

        if(props?.match?.params?.salesToken){
            body.salesToken = props?.match?.params?.salesToken
        }

        window.dataLayer.push({'event': 'form_submit_free_audit'});

        const { response, error } = await apiCall("members", {
            method: "POST",
            body
        })

        if(response){
            if (response["error"] || response["errorMessage"]) {
                toast.error(response["error"] || response["errorMessage"], {containerId: "signupToastContainer"})
                emailRef.current.focus()
            } else {
                toast.success("Form has been submitted! An email has been sent to your inbox", {containerId: "signupToastContainer"})
                setState(prev => ({
                    ...prev,
                    brand: INITIAL_STATE.brand,
                    domain: INITIAL_STATE.domain,
                    contactFirstName: INITIAL_STATE.contactFirstName,
                    contactLastName: INITIAL_STATE.contactLastName,
                    email: INITIAL_STATE.email,
                    cellPhone: INITIAL_STATE.cellPhone,
                    websiteType: INITIAL_STATE.websiteType,
                    militaryBranch: INITIAL_STATE.militaryBranch,
                    loading: false,
                    submitting: false
                }))
            }
        }
    }

    const items = [
        {
            src: '/images/isl-email.png',
          altText: 'Slide 1',
          caption: 'Slide 1',
          header: 'Slide 1 Header'
        },
        {
            src: '/images/isl-email.png',
          altText: 'Slide 2',
          caption: 'Slide 2',
          header: 'Slide 2 Header'
        },
        {
            src: '/images/isl-email.png',    
          altText: 'Slide 3',
          caption: 'Slide 3',
          header: 'Slide 3 Header'
        }
    ];

    const { 
        webTitle, 
        partnerLogo, 
        loading, 
        showServiceBranch, 
        showBusinessType,
        showDemoButton, 
        submitting,
        brand,
        protocol,
        domain,
        contactFirstName,
        contactLastName,
        email,
        cellPhone,
        websiteType,
        militaryBranch,
        backgroundImage,
        trialExtensionOverrideDays,
        referral
    } = state
    return <>
        {loading && <div id="cover-spin">
            <div class="d-flex justify-content-center align-items-center" style={{height: "100%"}}>
                <div class="spinner-grow" style={{width: "5rem", height: "5rem"}} role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>}
        {!isAuth && <ToastContainer
            containerId="signupToastContainer"
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover
        />}
        <section id="cover">
            <div class="row register register-with-news-feed" style={{
                backgroundImage: `url(${backgroundImage ? backgroundImage : blueBkImg})`, 
                backgroundSize: "cover", minHeight: "100%",
                backgroundPosition: "top center",
                backgroundRepeat: "no-repeat"
            }}>
                <div class="col-lg-6 d-md-none d-lg-flex news-feed flex-column justify-content-center">
                    <div class="news-caption">
                        <img src={monitorImg} className="d-block mx-auto img-fluid" />
                        <h2 className="text-white text-center font-weight-bold">Convert More Deals</h2>
                        <h4 className="text-white text-center">Review top KPIs with a multitude of integrations</h4>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12 register-container">
                    <Link to="/" class="mt-4 mx-auto d-block text-center">
                        <img class="logoTop" style={partnerLogo ? ({maxWidth: "400px", maxHeight: "200px"}) : {height: "80px"}} src={partnerLogo ? partnerLogo : (theme?.mainLogo ?? "https://engine.internetstrategylabs.com/images/insights-engine.png")} alt="Insights Engine Logo" />
                    </Link>
                    <div class="register-header">
                        <div class="mb-1 h2" style={{fontWeight: "505"}}>Create your Account, Get your Audit!</div>
                        <small class="d-block fs-15px lh-16">
                            <span style={trialExtensionOverrideDays ? ({
                                textDecoration: "line-through"
                            }) : {}}>7</span> <span className={`font-weight-bold ${!trialExtensionOverrideDays ? "d-none" : ""}`}>{trialExtensionOverrideDays}</span> day free trial. No credit card required.
                        </small>
                    </div>

                    <div class="register-content">
                        <form id="memberForm" class="form" onSubmit={onSubmitForm} data-rewardful="true">
                            <div class="mb-3">
                                <label class="mb-2">Company <span class="text-danger">*</span></label>
                                <input type="text" onChange={onInputChange} minLength={2} maxLength={50} class="form-control input-lg" name="brand" value={brand} placeholder="Company name" required />
                            </div>
                            <div class="mb-3">
                                <label class="mb-2">Website <span class="text-danger">*</span></label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <select class="form-control input-lg" name="protocol" value={protocol} onChange={onInputChange}>
                                            <option selected value="https://">https://</option>
                                            <option value="http://">http://</option>
                                        </select>
                                    </div>
                                    <input type="text" onChange={onInputChange} minLength={5} maxLength={75} title="Website URL" pattern="(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:\/[^\s]*)?" class="form-control input-lg" placeholder="Domain name" name="domain" value={domain} required />
                                    <div class="input-group-append d-none d-sm-flex">
                                        <button class="btn btn-sm btn-info" id="testSite" type="button" onClick={previewSite}>Test Site</button>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="mb-2">Name <span class="text-danger">*</span></label>
                                <div class="row gx-3">
                                    <div class="col-md-6 mb-2 mb-md-0">
                                        <input type="text" onChange={onInputChange} minLength={3} maxLength={25} class="form-control input-lg" placeholder="First name" name="contactFirstName" value={contactFirstName} required/>
                                    </div>
                                    <div class="col-md-6">
                                        <input type="text" onChange={onInputChange} minLength={3} maxLength={40} class="form-control input-lg" placeholder="Last name" name="contactLastName" value={contactLastName} required/>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="mb-2">Email <span class="text-danger">*</span></label>
                                <input type="email" ref={emailRef} onChange={onInputChange} maxLength={100} class="form-control input-lg" placeholder="Email address" name="email" value={email} required/>
                            </div>
                            <div class="mb-3">
                                <label class="mb-2">Cell Phone <span class="text-danger">*</span></label>
                                <ReactInputMask type="tel"
                                    pattern="\([0-9]{3}\)[ ]{1}[0-9]{3}-[0-9]{4}"
                                    title="Cell Phone Number"
                                    className="form-control input-lg"
                                    mask="(999) 999-9999"
                                    name="cellPhone" 
                                    maskChar={null}
                                    onChange={onInputChange}
                                    value={cellPhone} 
                                    placeholder="Cell Phone"
                                    required/>
                            </div>
                            <div class="mb-4">
                                {(showBusinessType && !showServiceBranch) && <label class="mb-2">Business Type <span class="text-danger">*</span></label>}
                                {showServiceBranch && <label class="mb-2">Military Branch <span class="text-danger">*</span></label>}
                                {(showBusinessType && !showServiceBranch) && <select onChange={onInputChange} class="form-control input-lg" name="websiteType" value={websiteType} {...(!showServiceBranch ? {required: true} : {})} style={{color: "rgb(134, 132, 132) !important", "--darkreader-inline-color": "#ada69b"}}>
                                    <option value="N/A" disabled="disabled" selected="selected" hidden="hidden">Business Type</option>
                                    <option value="Recruitment">FranDev Site</option>
                                    <option value="Brand">Brand/SMB</option>
                                    <option value="Veteran">Veteran Owned</option>
                                    <option value="Ecommerce">Ecommerce</option>
                                </select>}
                                {showServiceBranch && <select onChange={onInputChange} class="form-control input-lg" name="militaryBranch" value={militaryBranch} {...(showServiceBranch ? {required: true} : {})} style={{color: "rgb(134, 132, 132) !important", "--darkreader-inline-color": "#ada69b"}}>
                                    <option value="" disabled="disabled" selected="selected" hidden="hidden">Military Branch</option>
                                    <option value="army">Army</option>
                                    <option value="navy">Navy</option>
                                    <option value="airForce">Air Force</option>
                                    <option value="marines">Marines</option>
                                    <option value="coastGuard">Coast Guard</option>
                                    <option value="militarySpouse">Military Spouse</option>
                                </select>}
                            </div>
                            <div class="form-check mb-4">
                                <input class="form-check-input" type="checkbox" value="" id="agreementCheckbox" required />
                                <label class="form-check-label" for="agreementCheckbox">
                                    By signing up, you agree to our <a href="https://internetstrategylabs.com/terms-of-use/" target="_blank">Terms</a> and that you have read our <a href="https://internetstrategylabs.com/privacy-policy/" target="_blank">Privacy Policy</a>
                                </label>
                            </div>
                            { referral ? <input type="hidden" name="referral" value={referral} /> : null }
                            <div class="register-buttons">
                                <button type="submit" id="signup-btn" disabled={submitting} class="btn btn-success btn-block btn-lg">
                                    {submitting ? <div class="spinner-border text-light spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div> : <i className="fa fa-lock pr-2"></i>} Get Your Free Audit
                                </button>
                            </div>
                            <div class="text-center mt-sm-4 mt-4 mb-2 mb-sm-2">
                                <a style={{fontWeight:"bold"}} href="#">
                                    <span id="webTitle">{webTitle}</span> and Cover your Six are proprietary components of Internet Strategy Labs
                                </a>
                            </div>
                            <div class="mb-4 text-center mx-auto d-block">
                                Already a member? Click <Link to="/login">here</Link> to login.
                            </div>
                            <hr class="bg-gray-600 opacity-2" />
                            <p class="text-center text-gray-600">
                                © Internet Strategy Labs
                            </p>
                        </form>
                    </div>

                </div>

            </div>
        </section>
    </>
}

export default WelcomeSignup